export const SUBJECT_TYPE_FILTER_ALL = 'all'

export const parseSubjectTypeFilter = (value) => {
  if (value === SUBJECT_TYPE_FILTER_ALL || value === '' || value == null) {
    return null
  }

  return Number(value)
}
